import React, { useEffect, useMemo, useRef, useState } from 'react'
import "./column-selection-popup.scss"
import "./column-selection-header.scss"
import { ASButton } from '../../../shared/as-button/as-button'
import { Autocomplete, Box, Button, ButtonGroup, CardMedia, Chip, FormControl, MenuItem, OutlinedInput, Popper, Select, TextField, Tooltip } from '@mui/material'
import { Link } from 'react-router-dom'
import FilterPopupController from '../../../controllers/data-collections/column-selection/filter-popup/filter-popup-controller'
import MessageToaster from '../../../shared/message-toaster/message-toaster'
import { useASContext } from '../../../controllers/context-api/as-context';
import { AppEnum } from '../../../constants/app-enum';
import { RestServiceConstants } from '../../../constants/rest-service-constant'
import { truncateString } from '../../../shared/code-challanges/code-challanges'
import RefreshScheduleController from '../../../controllers/data-collections/refresh-schedule/refresh-schedule'

export default function ColumnSelectionHeader(props) {

    const { sortModal, filterModal, openSortModal, handleChangeObject, openFilterModal, closeFilterModal,
         handleSave, filterData, setFilterData, sortData, setSortData, columnsList, executeData, closeSortModal, 
         state, setState, selectedConnection, handleObjectChange, filterConfig, collectionFilterColumns, 
         closeLimitModal, openLimitModal, limitModal, limitData, setLimitData, handleAuthorizeAgain, isAuthorizeAgain, isOpenInDialog, showNativeDataVisualizer, excelDataState} = props;

    const isFilterSupported = (state?.childTemplateInheritedCollectionId || state?.childTemplateCollectionId) ?  !(state?.childTemplateCollectionObjects?.find(i => i.templateCollectionId == (state.childTemplateInheritedCollectionId || state?.childTemplateCollectionId))?.isFilterSupported) : 
                !(state?.cloudCollectionObjects?.find(i => i.templateCollectionId == state.templateCollectionId)?.isFilterSupported);
    const isSortSupported = (state?.childTemplateInheritedCollectionId || state?.childTemplateCollectionId) ?  !(state?.childTemplateCollectionObjects?.find(i => i.templateCollectionId == (state.childTemplateInheritedCollectionId || state?.childTemplateCollectionId))?.isSortSupported) : 
                !(state?.cloudCollectionObjects?.find(i => i.templateCollectionId == state.templateCollectionId)?.isSortSupported);
    const isPagingSupported = (state?.childTemplateInheritedCollectionId || state?.childTemplateCollectionId) ?  !(state?.childTemplateCollectionObjects?.find(i => i.templateCollectionId == (state.childTemplateInheritedCollectionId || state?.childTemplateCollectionId))?.isPagingSupported) : 
                !(state?.cloudCollectionObjects?.find(i => i.templateCollectionId == state.templateCollectionId)?.isPagingSupported);
                
    const isAllFilterNotSupported = (isFilterSupported && isSortSupported && isPagingSupported)
    const [searchQuery, setSearchQuery] = useState('');
    const [showRefreshSchedule, setShowRefreshSchedule] = useState(false);

    const refreshSchedule = () =>{
        setShowRefreshSchedule(true);
    }

    const transformGroupedData = (groupedData) => {
        return Object.entries(groupedData)
        .sort(([a], [b]) => a.localeCompare(b))
        .flatMap(([key, items]) => items.map(item => ({
            group: key,
            ...item,
        })));
    };
    
    const groupedObject = useMemo(() => {
        if (!state?.cloudCollectionObjects || state.cloudCollectionObjects.length == 0) {
            return {};
        }
        const allObject = [
            ...(state?.cloudCollectionObjects || []), 
            ...(state?.childTemplateCollectionObjects || [])
        ];
        return allObject?.reduce((groups, item) => {
        const group = item.groupName || '';
        const subGroup = item.childGroupName || '';
        const key = subGroup ? `${group}->${subGroup}` : group;
        if (!groups[key]) {
            groups[key] = [];
        }
        groups[key].push(item);
        return groups;
        }, {});
    }, [state?.cloudCollectionObjects]);
    
    const groupedOptions = useMemo(() => transformGroupedData(groupedObject), [groupedObject]);

    const asContext = useASContext();

    const CustomPopper = (props) => {
        return <Popper {...props} style={{ width: '', minWidth:'250px', maxWidth:'412px'}} placement="bottom-start" />;
    };

    const connectionName = useMemo(() => {
        return selectedConnection?.connectionName?.split(' ').slice(0, 2).join(' ');
    }, [selectedConnection?.connectionName]);

    const collectionTypeName = useMemo(() => {
    return state?.collectionTypeList?.find(i => i.id === state?.sysCollectionTypeId)?.typeName;
    }, [state?.collectionTypeList, state?.sysCollectionTypeId]);

    const connectionAuthType = useMemo(() => {
        return selectedConnection?.parameters?.find(
            param => param.parameterName === RestServiceConstants.AUTH_TYPE
        )?.parameterValue;
    }, [selectedConnection]);

    const connectionGrantType = useMemo(() => {
        return selectedConnection?.parameters?.find(
            param => param.parameterName === RestServiceConstants.OAUTH2_INPUTS.GRANT_TYPE
        )?.parameterValue;
    }, [selectedConnection]);


  return (
    <div className="column-selection-header-container">
        <div className="column-header-part-one">
            
            <div className="icon-image-div">
                <CardMedia
                            component="img"
                            sx={{ width: "auto !important", height: '65px' }}
                            image={`/assets/${selectedConnection?.connectionTypeIconImage}`}
                            alt={`${selectedConnection?.connectionTypeIconImage}`}
                        />
            </div>

            <div className={ showNativeDataVisualizer ? 'content-div-flex' : 'content-div' }>
                <div className={`${!showNativeDataVisualizer ? 'columns-selection-header-name-div' : 'native-columns-selection-header-name-div'}`}>
                    <label>{truncateString(state?.name, 28)}</label>
                    <span>{" "}- {!showNativeDataVisualizer ? "Select Columns, Filter and Sort" : "Select Columns"}</span>
                </div>
                {
                    !showNativeDataVisualizer ? (
                                <div className="column-flex-div">
                            <div className="column-header-name-container">
                                {/* <CardMedia
                                    component="img"
                                    sx={{ width: "auto !important", height: '30px' }}
                                    image={`/assets/${selectedConnection?.connectionTypeIconImage}`}
                                    alt={`${selectedConnection?.connectionTypeIconImage}`}
                                /> */}
                                <div className="column-header-name">
                                    <span>Connect</span>

                                    <Autocomplete
                                        className="connector-name-label"
                                        PopperComponent={CustomPopper}
                                        sx={{
                                            width: '100% !important',
                                            boxShadow: 'none',
                                            marginTop: '0px',
                                            maxWidth: '250px',
                                            
                                            '& .MuiInputBase-root': {
                                                padding: 0,
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                padding: 0,
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none !important',
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none !important',
                                                },
                                                '& .MuiAutocomplete-input': {
                                                    color: "#16365F !important",
                                                    fontWeight: "700",
                                                    fontSize: "13px",
                                                    padding: '3px',
                                            }
                                            },
                                            '&:hover .MuiOutlinedInput-root': {
                                                border: '1px solid grey',
                                            },
                                            '& .MuiSelect-select': {
                                                padding: '0px 8px',
                                                marginTop: '1px'
                                            },
                                            '&::before': {
                                                borderBottom: 'none !important',
                                            },
                                            '&::after': {
                                                borderBottom: 'none !important',
                                            },
                                            '& .MuiBox-root': {
                                                width: '100%',
                                            },
                                            
                                        }}
                                        options={groupedOptions}
                                        groupBy={(option) => option.group}
                                        getOptionLabel={(option) => option.name}
                                        value={
                                            [
                                              ...(state?.childTemplateCollectionObjects ?? []),
                                              ...(state?.cloudCollectionObjects ?? [])
                                            ].find(item =>
                                              (state?.childTemplateInheritedCollectionId || state?.childTemplateCollectionId)
                                                ? item.templateCollectionId === (state?.childTemplateInheritedCollectionId || state?.childTemplateCollectionId)
                                                : item.templateCollectionId === state?.templateCollectionId
                                            ) ?? null
                                        }                                          
                                        onChange={(event, newValue) => {
                                            handleObjectChange({ target: { value: newValue?.templateCollectionId } });
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                        )}
                                        renderOption={(props, option) => (
                                            <Box component="li" {...props} key={option.templateCollectionId} sx={{ 
                                                whiteSpace: 'nowrap', 
                                                overflow: 'hidden', 
                                                fontSize: '13px',
                                                height: '30px',
                                                // textOverflow: 'ellipsis',
                                                // width: '100%',
                                            }}>
                                                {option.name}
                                            </Box>
                                        )}
                                        renderGroup={(params) => (
                                            <div key={params.key}>
                                                <Box sx={{
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    fontSize: '13px',
                                                    // textOverflow: 'ellipsis',
                                                    // width: '100%',
                                                    fontWeight: 'bold', 
                                                    padding: '4px 8px',
                                                    color: "#16365F !important" 
                                                }}>
                                                    {params.group}
                                                </Box>
                                                {params.children}
                                            </div>
                                        )}
                                        isOptionEqualToValue={(option, value) => option.templateCollectionId === value.templateCollectionId}
                                        disableClearable={true}
                                        clearOnEscape={false} 
                                    />
                                </div>
                            </div>
                    {isOpenInDialog && <div className='change-div-container'>
                        <Link to="#" className="change-link" onClick={() => handleChangeObject()}><span >Go Back</span></Link>
                    </div>}
                        </div>
                    ) : (
                        <></>
                    )
                }
            </div>
        </div>

        {((state?.cloudCollectionError && (state?.cloudCollectionError?.statusCode === "Unauthorized" || state?.cloudCollectionError?.httpStatus === 401 || state?.cloudCollectionError?.errorMessage === "Unauthorized")) || (state?.nativeCollectionError === "Unauthorized")) && 
         (asContext?.tenants?.selectedTenant?.UserRoleId === AppEnum.UserRoleIds.CompanyAdmin) &&
            <div>
                <div className='pop-error-div'>
                    {<MessageToaster sx={{padding:"4px !important"}} errorMessage={"Unauthorized"} />}
                </div>
                {(connectionAuthType == AppEnum.RestConnnectionTypes.OAuth_2 && (connectionGrantType == "authorization_code" || connectionGrantType == "authorization_code_with_pkce")) && <div>
                    <ASButton variant="contained" 
                            onClick={handleAuthorizeAgain} 
                            primary={true} 
                            disabled={state?.isTestingConnection}
                            sx={{ padding:"4px 13px" }}>
                                Authorize Again
                    </ASButton>
                </div>}
            </div>}

        <div className="column-selection-header-btn-div">
            {state?.uId &&  (asContext?.tenants?.selectedTenant?.UserRoleId !== AppEnum.UserRoleIds.CollectionUser) &&
                <div className='refresh-schedule' onClick={refreshSchedule} >
                    <Tooltip title="Refresh Schedule">
                        <img src="/assets/refresh-schedule.svg" alt="Refresh" />
                    </Tooltip>
                </div>
            }
            {!isAllFilterNotSupported && !showNativeDataVisualizer && <div className='filter-sort-btn-div'>

                <ButtonGroup variant="outlined" aria-label="Basic button group">
                    {/* <div className={`filter-div-header ${filterData?.length > 0 ? 'selected-filter-sort' : ''}`}> */}
                    <Tooltip title={isFilterSupported ? "Filter is not supported for this object" : ""}>
                        <div className={`filter-div-header ${filterData?.length > 0 ? 'selected-filter-sort' : ''}`}>
                            <Button onClick={() => openFilterModal()} disabled={isFilterSupported} 
                                    sx={{'&:disabled': {backgroundColor: '#efefef'}}}>
                                {<div>
                                    {filterData?.length > 0 ? <img src="/assets/filterWhite.svg" alt="Filter" /> : <img src="/assets/filter.svg" alt="Filter" />}
                                    <label>Filter</label>
                                </div>}
                            </Button>
                        
                            <FilterPopupController open={filterModal} 
                                            closeFilterModal={closeFilterModal}
                                            filterData={filterData}
                                            setFilterData={setFilterData}
                                            columnsList={columnsList}
                                            executeData={executeData}
                                            state={state}
                                            setState={setState}
                                            filterConfig={filterConfig}
                                            collectionFilterColumns={collectionFilterColumns}/>
                        </div>
                    </Tooltip>
                    <Tooltip title={isSortSupported ? "Sort is not supported for this object" : ""}>
                        <div className={`filter-div-header ${sortData?.length > 0 ? 'selected-sort' : ''}`}>
                            <Button onClick={() => openSortModal()} disabled={isSortSupported}
                                    sx={{'&:disabled': {backgroundColor: '#efefef'}}}>
                                    {<div>
                                        {sortData?.length > 0 ? <img src="/assets/sortWhite.svg" alt="Sort" /> : <img src="/assets/sort.svg" alt="Sort" />}
                                        <label>Sort</label>
                                    </div>}
                            </Button>
                            <FilterPopupController open={sortModal} 
                                            closeFilterModal={closeSortModal}
                                            sortData={sortData}
                                            setSortData={setSortData}
                                            columnsList={columnsList}
                                            executeData={executeData}
                                            isSort={true}
                                            state={state}
                                            setState={setState}
                                            filterConfig={filterConfig}/>
                        </div>
                    </Tooltip>
                    <Tooltip title={isPagingSupported ? "Limit is not supported for this object" : ""}>
                        <div  className={`filter-div-header ${limitData ? 'selected-sort' : ''}`}>
                            <Button onClick={() => openLimitModal()} disabled={isPagingSupported} sx={{'&:disabled': {backgroundColor: '#efefef'}}}>{<div>{limitData ? <img src="/assets/limitWhite.svg" alt="Limit" /> : <img src="/assets/limit.svg" alt="Limit" />}<label>Limit</label></div>}</Button>
                            <FilterPopupController open={limitModal} 
                                            closeLimitModal={closeLimitModal}
                                            limitData={limitData}
                                            setLimitData={setLimitData}
                                            columnsList={columnsList}
                                            executeData={executeData}
                                            isLimit={true}
                                            state={state}
                                            setState={setState}
                                            filterConfig={filterConfig}/>
                        </div>
                    </Tooltip>
                </ButtonGroup>
            </div>}
            <ASButton variant="contained" disabled={(state?.cloudCollectionError || state?.nativeCollectionError) ? true : false } sx={{ mr: 4 }} primary={true} onClick={() => handleSave()}>{(excelDataState?.isCommandFromExcel && excelDataState?.isEditMode) ? "Run & Save" : "Save"}</ASButton>
            <div >
                {/* <Button > */}
                    {<div className='close-popup-div' onClick={() => handleChangeObject(true)}>
                        <img src="/assets/close.svg" alt="Close" className="close-icon"/>
                    </div>}
                {/* </Button> */}
            </div>
            {showRefreshSchedule && state?.uId &&
                <RefreshScheduleController
                    collectionUId={state?.uId}
                    setIsOpenDialog={setShowRefreshSchedule}
                    isOpenDialog={showRefreshSchedule} />
            }
        </div>
    </div>
  )
}
